module.exports = __webpack_public_path__ + "img/lg_ring_r_0_null_1.14cee6b4.png";